/* globals jQuery, wordpress_globals */

import "../sass/theme.scss";

import $ from "jquery";
import svgxhr from "webpack-svgstore-plugin/src/helpers/svgxhr";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

import nav from "./modules/nav";
import ix from "./modules/ix";
import loadMorePosts from "./modules/loadMorePosts";
import termsDropdown from "./modules/termsDropdown";
import workbooksForm from "./modules/workbooksForm";
import forms from "./modules/forms";
import nameShout from "./modules/nameShout";
import headerVideo from "./modules/headerVideo";
import accordionSliderSection from "./modules/accordionSliderSection";
import careersAccordionSection from "./modules/careersAccordionSection";
import genericAccordionSection from "./modules/genericAccordionSection";
import clientsSliderSection from "./modules/clientsSliderSection";
import featuresSection from "./modules/featuresSection";
import fullwidthEmbedSection from "./modules/fullwidthEmbedSection";
import imageCopySection from "./modules/imageCopySection";
import imagesGridZoomSection from "./modules/imagesGridZoomSection";
import imagesSliderSection from "./modules/imagesSliderSection";
import statisticsSection from "./modules/statisticsSection";
import postsSliderSection from "./modules/postsSliderSection";
import workSliderSection from "./modules/workSliderSection";
import peopleSliderSection from "./modules/peopleSliderSection";
import quotesSliderSection from "./modules/quotesSliderSection";
import Map from "./modules/Map";
import Accordion from "./modules/Accordion";
import RedirectModal from "./modules/RedirectModal";
import modals from "./modules/modals";

window.lazySizesConfig = window.lazySizesConfig || {};

window.headland = {
    init: function () {

        this.helpers.initSvg();

        // Allow user to interrupt auto-scrolling
        $(document).bind('scroll mousedown wheel keyup', function (e) {
            if (e.which || e.type === 'mousedown' || e.type === 'mousewheel') {
                $(document.scrollingElement).stop();
            }
        });

        // Modals
        modals.init();

        // Components
        termsDropdown.init();
        workbooksForm.init();
        forms.init();
        nameShout.init();

        // Headers
        headerVideo.init();

        // Sections
        accordionSliderSection.init();
        careersAccordionSection.init();
        genericAccordionSection.init();
        clientsSliderSection.init();
        featuresSection.init();
        fullwidthEmbedSection.init();
        imageCopySection.init();
        // imagesGridZoomSection.init(); // fixme: ix does not behavior as desired
        imagesSliderSection.init();
        statisticsSection.init();

        // Post Sliders
        postsSliderSection.init();
        workSliderSection.init();
        peopleSliderSection.init();
        quotesSliderSection.init();

        // Globals
        nav.init();
        ix.init();

        loadMorePosts.init();

        new RedirectModal(document.getElementById('redirect'));

        const map = new Map('.section--map__map', '.js-hotspot-btn');
        map.overrideHotspotActiveClass('hotspot__button--active')
        map.overrideHotspotActiveClassLeftSide('hotspot__button--left');
        map.overrideHotspotActiveClassRightSide('hotspot__button--right');
        map.init();

        (document.querySelectorAll('.hotspot__content') || []).forEach((accordion) => new Accordion(accordion, 'click'));
    },
    helpers: {
        requireAll: function (r) {
            r.keys().forEach(r);
        },
        initSvg: function () {
            svgxhr({
                filename: './wp-content/themes/class/dist/sprite.svg', // URL to fetch
            });
        }
    }

    // Prefer creating new modules when appropriate, rather than adding functions here
    // If you need something to be globally accessible, you can assign an imported module to this namespace
    // i.e. import Contact from './contact';
    //  window.namespace.Contact = Contact;
};

window.headland.init();

if (typeof NodeList.prototype.forEach !== 'function') {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// SVG Sprite Loader
window.headland.helpers.requireAll(require.context('../images/icons/', true, /\.svg$/));
